module.exports = __webpack_public_path__ + "img/commando_ios_802.png";